import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const PhotoGalleryContext = createContext({
  isCustomerPortal: false
});

export function PhotoGalleryProvider({ children, isCustomerPortal }) {
  const value = useMemo(() => ({ isCustomerPortal }), [isCustomerPortal]);
  return <PhotoGalleryContext.Provider value={value}>{children}</PhotoGalleryContext.Provider>;
}

PhotoGalleryProvider.propTypes = {
  children: PropTypes.node.isRequired,
  isCustomerPortal: PropTypes.bool
};

PhotoGalleryProvider.defaultProps = {
  isCustomerPortal: false
};

export const usePhotoGalleryContext = () => {
  const context = useContext(PhotoGalleryContext);
  if (!context) {
    throw new Error('usePhotoGalleryContext must be used within PhotoGalleryProvider');
  }
  return context;
};

export default PhotoGalleryContext;
